/* House of Suave feature analytics
   One call, three destinations: GA4 (gtag), Microsoft Clarity, Shopify customer events.
   Every event is prefixed hos_ and carries: feature, page_type, plus event-specific params.
   Order attribution: features a shopper interacts with are written to the cart as the
   attribute hos_features, which appears on the order in Shopify admin.
   Debug: open any page with ?hos_debug=1 to log every event in the console (?hos_debug=0 to stop). */
(function () {
  if (window.__hosTrackReady) return;
  window.__hosTrackReady = true;

  var DEBUG = false;
  try {
    if (/[?&]hos_debug=1/.test(location.search)) localStorage.setItem('hos_debug', '1');
    if (/[?&]hos_debug=0/.test(location.search)) localStorage.removeItem('hos_debug');
    DEBUG = localStorage.getItem('hos_debug') === '1';
  } catch (e) {}

  var meta = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || {};
  var pageType = (meta.page && meta.page.pageType) || '';
  var pageProduct = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';

  var FEATURES = [
    ['plp_', 'plp'], ['collection_seo', 'plp'], ['home_', 'homepage'],
    ['offer_', 'bundle_offer'], ['bundle_', 'bundle_offer'],
    ['sticky_', 'sticky_atc'], ['stock_', 'stock_line'], ['oos_helper', 'oos_size_helper'],
    ['colourway', 'colourways'], ['size_chart', 'size_chart'], ['description_', 'description'],
    ['recently_viewed', 'recently_viewed'], ['pdp_', 'pdp']
  ];
  function featureOf(n) { for (var i = 0; i < FEATURES.length; i++) if (n.indexOf(FEATURES[i][0]) === 0) return FEATURES[i][1]; return 'other'; }
  var PASSIVE = /(_view|_shown|_results|_empty)$/;

  function touch(f) {
    try {
      var t = JSON.parse(sessionStorage.getItem('hos_touch') || '[]');
      if (t.indexOf(f) === -1) { t.push(f); sessionStorage.setItem('hos_touch', JSON.stringify(t)); }
    } catch (e) {}
  }

  var log = window.__hosLog = window.__hosLog || [];
  function track(name, params) {
    var p = {}, k;
    params = params || {};
    for (k in params) {
      var v = params[k];
      if (v === undefined || v === null || v === '') continue;
      p[k] = typeof v === 'string' ? v.slice(0, 100) : v;
    }
    p.feature = p.feature || featureOf(name);
    p.page_type = pageType;
    if (pageProduct && !p.product_page) p.product_page = pageProduct;
    var ev = 'hos_' + name;
    try { if (typeof window.gtag === 'function') window.gtag('event', ev, p); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('event', ev); if (!PASSIVE.test(name)) window.clarity('set', 'hos_' + p.feature, 'used'); } } catch (e) {}
    if (!PASSIVE.test(name)) touch(p.feature);
    log.push({ t: Date.now(), event: ev, params: p });
    if (DEBUG) try { console.log('%c' + ev, 'color:#2F070E;font-weight:700', p); } catch (e) {}
  }
  window.hosTrack = track;
  var q = window.__hosQ || [];
  window.__hosQ = [];
  for (var i = 0; i < q.length; i++) track(q[i][0], q[i][1]);

  /* Order attribution: stamp touched features on the cart after each add */
  var synced = '';
  function syncCart() {
    var t = [];
    try { t = JSON.parse(sessionStorage.getItem('hos_touch') || '[]'); } catch (e) {}
    if (!t.length) return;
    var v = t.join(',');
    if (v === synced) return;
    synced = v;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { hos_features: v } }) })
      .catch(function () { synced = ''; });
  }
  window.hosSyncCart = syncCart;
  var hooked = false;
  function hook() {
    if (hooked) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      hooked = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncCart, 300); });
    }
  }
  hook();
  if (!hooked) { document.addEventListener('DOMContentLoaded', hook); window.addEventListener('load', hook); }

  /* Helpers */
  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function handleOf(href) { var m = String(href || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  function collOf(href) { var m = String(href || '').match(/\/collections\/([^/?#]+)/); return m ? m[1] : ''; }
  function pathOf(href) { try { return new URL(href, location.href).pathname; } catch (e) { return ''; } }
  function indexIn(el, sel) { var list = document.querySelectorAll(sel); for (var i = 0; i < list.length; i++) if (list[i] === el) return i + 1; return 0; }
  function plp() { return document.querySelector('[data-hos-plp]'); }
  function sectionOf(el) { var s = el.closest('.shopify-section'); return s ? s.id.replace(/^shopify-section-(template--\d+__)?/, '') : ''; }
  function helperSize() { var s = document.querySelector('hos-size-help [data-select]'); return s ? s.value : ''; }

  /* Clicks (capture phase, so this runs before each button's own handler and sees the pre-click state).
     First matching selector wins, so specific ones come first. */
  var CLICKS = [
    ['.hos-plp__chip', function (el) { var p = plp(); return ['plp_size_chip_click', { size: txt(el), was_active: el.classList.contains('is-on') ? 1 : 0, collection: p && p.dataset.collection }]; }],
    ['.hos-pcard', function (el) { var p = plp(); return ['plp_product_click', { product: handleOf(el.href), position: indexIn(el, '.hos-pcard'), size_filter: p && p.dataset.size, collection: p && p.dataset.collection, low_stock: el.querySelector('.hos-pcard__avail.is-low') ? 1 : 0 }]; }],
    ['.hos-plp__tile a', function () { return ['plp_fit_tile_click', {}]; }],
    ['.hos-plp__pbtn', function (el) { return ['plp_pagination_click', { label: txt(el) }]; }],
    ['.hos-cseo__more', function (el) { return ['collection_seo_read_more', { opened: txt(el) === 'Read more' ? 1 : 0 }]; }],
    ['[data-hos-rv] .hos-card', function (el) { return ['recently_viewed_click', { product: handleOf(el.href), position: indexIn(el, '[data-hos-rv] .hos-card') }]; }],
    ['.hos-car .hos-btn, .hos-car .hos-link', function (el) { return ['home_hero_cta_click', { label: txt(el), target: pathOf(el.href) }]; }],
    ['.hos-car__dot, .hos-car__arrow', function (el) { return ['home_carousel_nav', { control: el.classList.contains('hos-car__dot') ? 'dot' : 'arrow' }]; }],
    ['.hos-cat', function (el) { return ['home_category_click', { collection: collOf(el.href), label: txt(el.querySelector('.hos-cat__name')) }]; }],
    ['.hos-size', function (el) { return ['home_size_rail_click', { size: txt(el) }]; }],
    ['.hos-colours__swatch', function (el) { return ['home_colour_swatch_click', { colour: el.getAttribute('aria-label') || '' }]; }],
    ['.hos-tabs__tab', function (el) { return ['home_tab_switch', { tab: txt(el) }]; }],
    ['.hos-buy__size', function (el) { return ['home_spotlight_size_click', { size: txt(el) }]; }],
    ['.hos-buy__add', function (el) { return ['home_spotlight_add_click', { section: sectionOf(el) }]; }],
    ['.hos-card', function (el) { return ['home_product_click', { product: handleOf(el.href), section: sectionOf(el) }]; }],
    ['.hos-story a, .hos-spot a', function (el) { return ['home_story_cta_click', { label: txt(el), target: pathOf(el.href) }]; }],
    ['.hos-scb', function () { return ['size_chart_open', {}]; }],
    ['.hos-desc-more', function (el) { return ['description_read_more', { opened: txt(el) === 'Read more' ? 1 : 0 }]; }],
    ['[data-hos-sv]', function (el) { return ['offer_details_toggle', { opened: el.getAttribute('aria-expanded') === 'true' ? 0 : 1 }]; }],
    ['.stc__link', function (el) { return ['colourway_click', { to_product: handleOf(el.href), is_current: el.classList.contains('stc__link--current') ? 1 : 0, position: indexIn(el, '.stc__link') }]; }],
    ['[data-stc-next], [data-stc-prev]', function (el) { return ['colourway_scroll', { direction: el.hasAttribute('data-stc-next') ? 'next' : 'prev' }]; }],
    ['hos-size-help [data-cta]', function (el) { return ['oos_helper_cta_click', { size: helperSize(), target: pathOf(el.href) }]; }],
    ['hos-size-help [data-close]', function () { return ['oos_helper_dismiss', { size: helperSize() }]; }]
  ];
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < CLICKS.length; i++) {
      var el = t.closest(CLICKS[i][0]);
      if (el) { var r = CLICKS[i][1](el); if (r) track(r[0], r[1]); return; }
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-hos-sort]')) track('plp_sort_change', { sort_by: t.value });
    else if (t.matches('hos-size-help [data-select]')) track('oos_helper_size_change', { size: t.value });
  }, true);

  /* Main product form: add to cart, tagged with where the tap came from */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
    if (!f.closest('.product__info-container, product-info, .product')) return;
    var id = (f.querySelector('input[name="id"]') || {}).value, size = '';
    try { JSON.parse(document.querySelector('[data-hos-variants]').textContent).forEach(function (v) { if (String(v.id) === String(id)) size = v.size; }); } catch (err) {}
    var viaSticky = window.__hosStickyTap && Date.now() - window.__hosStickyTap < 2000;
    track('pdp_add_to_cart', { size: size, source: viaSticky ? 'sticky_bar' : 'main_button' });
  }, true);

  /* Views: fire once when at least half the element is on screen */
  function onView(sel, name, paramsFn) {
    var el = document.querySelector(sel);
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); track(name, paramsFn ? paramsFn(el) : {}); } });
    }, { threshold: 0.5 });
    io.observe(el);
  }
  function onReady() {
    var p = plp();
    if (p && p.dataset.size) {
      var n = parseInt(p.dataset.count, 10) || 0;
      track(n ? 'plp_size_results' : 'plp_size_empty', { size: p.dataset.size, results: n, collection: p.dataset.collection });
    }
    onView('.hos-plp__tile', 'plp_fit_tile_view');
    onView('[data-hos-nudge] [data-n-offer]:not([hidden])', 'offer_panel_view');
    onView('.stc', 'colourways_view', function (el) { return { count: el.querySelectorAll('.stc__link').length }; });
    onView('[data-hos-rv]:not([hidden])', 'recently_viewed_view');
    /* Sold-out size helper: report the first time its strip appears */
    var card = document.querySelector('hos-size-help [data-card]');
    if (card) {
      var shown = false, check = function () { if (!shown && !card.hidden) { shown = true; track('oos_helper_shown', { size: helperSize() }); } };
      check();
      if ('MutationObserver' in window) new MutationObserver(check).observe(card, { attributes: true, attributeFilter: ['hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
